import { useState } from "react";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("general");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email || !message) return;
    setLoading(true);
    try {
      await fetch("https://tribaltech-backend.onrender.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, subject, message }),
      });
    } catch (e) {}
    setSubmitted(true);
    setLoading(false);
  };

  const SUBJECTS = [
    { id: "general", label: "General inquiry" },
    { id: "dmca", label: "DMCA / takedown question" },
    { id: "billing", label: "Billing or subscription" },
    { id: "technical", label: "Technical support" },
    { id: "clean_slate", label: "Clean Slate — former creator" },
    { id: "press", label: "Press or partnership" },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#06060a", color: "#f0ede8", fontFamily: "'DM Sans', sans-serif", padding: "80px 24px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input, textarea, select { background: rgba(255,255,255,0.04); border: 0.5px solid rgba(255,255,255,0.12); border-radius: 8px; padding: 12px 16px; font-size: 14px; color: #f0ede8; font-family: inherit; width: 100%; outline: none; transition: border-color 0.2s; }
        input:focus, textarea:focus, select:focus { border-color: rgba(123,94,167,0.6); }
        select option { background: #1a1a2e; color: #f0ede8; }
        textarea { resize: vertical; min-height: 140px; line-height: 1.6; }
        .btn-primary { background: #7B5EA7; color: #fff; border: none; border-radius: 8px; padding: 14px; font-size: 15px; font-weight: 500; cursor: pointer; font-family: inherit; width: 100%; transition: background 0.2s; }
        .btn-primary:hover { background: #6a4f93; }
        .btn-primary:disabled { background: rgba(123,94,167,0.4); cursor: not-allowed; }
        a { color: #7B5EA7; text-decoration: none; }
      `}</style>

      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <a href="/" style={{ fontSize: 13, color: "rgba(240,237,232,0.4)", display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 40 }}>← Back to Creator Protect</a>

        {!submitted ? (
          <>
            <div style={{ marginBottom: 40 }}>
              <h1 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 36, fontWeight: 400, marginBottom: 10 }}>Get in touch</h1>
              <p style={{ fontSize: 14, color: "rgba(240,237,232,0.5)", lineHeight: 1.7 }}>We're here to help. Expect a response within 24 hours.</p>
            </div>

            {/* Contact options */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 36 }}>
              {[
                { icon: "◈", label: "DMCA support", email: "dmca@creatorprotect.io" },
                { icon: "◉", label: "Billing", email: "billing@creatorprotect.io" },
                { icon: "◎", label: "Technical", email: "support@creatorprotect.io" },
                { icon: "◌", label: "Privacy", email: "privacy@creatorprotect.io" },
              ].map((c, i) => (
                <div key={i} style={{ background: "rgba(255,255,255,0.02)", border: "0.5px solid rgba(255,255,255,0.07)", borderRadius: 10, padding: "14px 16px" }}>
                  <div style={{ fontSize: 16, color: "#7B5EA7", marginBottom: 6 }}>{c.icon}</div>
                  <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 4 }}>{c.label}</div>
                  <a href={`mailto:${c.email}`} style={{ fontSize: 11, color: "rgba(240,237,232,0.4)" }}>{c.email}</a>
                </div>
              ))}
            </div>

            <div style={{ border: "0.5px solid rgba(255,255,255,0.07)", borderRadius: 14, padding: 28 }}>
              <div style={{ fontSize: 11, fontWeight: 500, color: "rgba(240,237,232,0.4)", letterSpacing: "0.08em", marginBottom: 20 }}>SEND US A MESSAGE</div>

              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                <div>
                  <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Your name</label>
                  <input type="text" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Email address</label>
                  <input type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Subject</label>
                  <select value={subject} onChange={e => setSubject(e.target.value)}>
                    {SUBJECTS.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 12, color: "rgba(240,237,232,0.45)", display: "block", marginBottom: 6 }}>Message</label>
                  <textarea placeholder="How can we help?" value={message} onChange={e => setMessage(e.target.value)} />
                </div>
                <button className="btn-primary" onClick={handleSubmit} disabled={loading || !email || !message}>
                  {loading ? "Sending..." : "Send message"}
                </button>
              </div>
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <div style={{ fontSize: 36, color: "#0D9488", marginBottom: 20 }}>◉</div>
            <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 28, fontWeight: 400, marginBottom: 12 }}>Message received</h2>
            <p style={{ fontSize: 14, color: "rgba(240,237,232,0.5)", lineHeight: 1.7, marginBottom: 32 }}>We'll get back to you at {email} within 24 hours.</p>
            <a href="/" style={{ fontSize: 14, color: "#7B5EA7" }}>← Back to Creator Protect</a>
          </div>
        )}

        <div style={{ marginTop: 40, fontSize: 12, color: "rgba(240,237,232,0.25)", textAlign: "center" }}>
          © 2026 Creator Protect. All rights reserved.
        </div>
      </div>
    </div>
  );
}
